<template>
    <small>
        <b-overlay :show="!items">
            <b-table :fields="fields" :items="items" small bordered table-class="small-text print-table" class="mb-0"
                show-empty>
                <template #empty>
                    <div class="text-center my-2 fs-5">
                        No hay declaraciones que coincidan con los criterios de búsqueda
                    </div>
                </template>

                <template #cell(answers)="data">
                    <div class="d-flex flex-column">
                        <div v-for="(answer, index) in data.item.answers" :key="index" class="mb-1">
                            <b>{{ answer.questionName }}:</b> {{ formatBoolean(answer.answerIsCorrect) }}

                            <span v-if="answer.questionDeepening">
                                <br>
                                <div class="ms-3 text-break">{{ answer.answerTextDepth }}</div>
                            </span>
                        </div>
                    </div>
                </template>
            </b-table>
        </b-overlay>
    </small>
</template>

<script>
import { formatBoolean, formatDateTime } from '@/plugins/complianceScripts';

export default {
    name: 'StatementReportTable',

    props: {
        items: Array,
    },

    data() {
        return {
            fields: [
                { key: 'declarantName', label: 'Nombre declarante', thClass: "text-center col-2", tdClass: "align-middle" },
                { key: 'declarantMail', label: 'Correo declarante', thClass: "text-center col-2", tdClass: "align-middle" },
                { key: 'creationDate', label: 'Fecha de creación', thClass: "text-center col-2", formatter: formatDateTime, tdClass: "text-center align-middle" },
                { key: 'answers', label: 'Respuestas', thClass: "text-center col-6" },
            ]
        }
    },

    methods: {
        formatBoolean,
        formatDateTime,
    }
}
</script>

<style scoped>
.assistants-container {
    text-align: left;
}

.minimal-list {
    list-style: none;
    padding-left: 0.2rem;
    margin: 0.2rem 0;
    padding-left: 1em;
}

.minimal-list li::before {
    content: "- ";
    display: inline-block;
    width: 1em;
    margin-left: -1em;
}

.small-text {
    font-size: 0.875em;
}

.small-text th {
    font-size: 0.875em;
    font-weight: bold;
}
</style>